export const truncateText = (text: string, maxLengthBeforeTruncate: number) =>
  text?.length > maxLengthBeforeTruncate ? `${text.slice(0, maxLengthBeforeTruncate - 3)}...` : text;
